import React from "react";
import FormattedDate from "./FormattedDate";
import Temperature from "./Temperature";
import "./weatherinfo.css";

export default function WeatherInfo(props) {
  return (
    <div className="weatherInfo">
      <div>
        <h1>{props.info.placename}</h1>
      </div>
      <div className="dailyInfo">
        <ul id="daily-info">
          <li>
            <FormattedDate date={props.info.date} />
          </li>
          <li id="description" className="text-capitalize">
            {props.info.description}
          </li>
        </ul>
      </div>
      <div className="row Temperature">
        <div className="col-6">
          <div className="d-flex ">
            <div>
              <img src={props.info.icon} alt={props.info.description} />
            </div>
            <div>
              <Temperature unit={props.info.temperature} />
            </div>
          </div>
        </div>

        <div className="col-6 weatherDetails">
          <ul>
            <li>
              Humidity: <span>{props.info.humidity}</span>%
            </li>
            <li>
              Wind: <span> {props.info.wind}</span>km/h
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
